import React from 'react';
import { useNewSurgerie } from '../../hooks/useNewSurgerie';
import ProceduresAutoComplete from 'components/autocomplete/ProceduresAutoComplete';
import SpecialtiesAutoComplete from 'components/autocomplete/SpecialtiesAutoComplete';
import { Chip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import {
  CardBody,
  GuidedCard,
  GuidedHeader,
  HelperNote,
  SoftPanel,
  SplitGrid,
  ThreeGrid,
} from '../../components/GuidedSurgerie';

const SurgerieSecondStep: React.FC = () => {
  const { surgerie, handleChange, validation } = useNewSurgerie();
  return (
    <GuidedCard>
      <GuidedHeader
        step={2}
        title="Procedimento"
        description="Defina especialidade e procedimento para carregar médicos, hospitais e pacotes compatíveis."
        aside={surgerie.procedure ? <Chip color="primary" size="small" label="Base carregada" /> : undefined}
      />
      <CardBody>
        <SplitGrid>
          <SoftPanel>
            <Typography variant="subtitle2" gutterBottom>
              1. Escolha a especialidade
            </Typography>
            <SpecialtiesAutoComplete
              onSelect={specialty => {
                handleChange('specialty', specialty);
                handleChange('specialty_id', specialty?.id ?? null);
              }}
              label="Informe a especialidade"
              placeholder="Digite o nome da especialidade"
              selected={surgerie.specialty}
              error={!!validation}
              helperText={validation}
            />
          </SoftPanel>

          <SoftPanel>
            <Typography variant="subtitle2" gutterBottom>
              2. Escolha o procedimento
            </Typography>
            <ProceduresAutoComplete
              type="P"
              specialtyId={surgerie.specialty_id}
              disabled={!surgerie.specialty_id}
              label="Informe o procedimento"
              onSelect={procedure => {
                handleChange('procedure', procedure);
                handleChange('procedure_id', procedure?.id ?? null);
              }}
              placeholder="Digite o nome do procedimento"
              selected={surgerie.procedure}
              error={!!validation}
              helperText={validation}
            />
          </SoftPanel>
        </SplitGrid>

        {surgerie.procedure ? (
          <ThreeGrid>
            <SoftPanel>
              <Typography variant="caption" color="textSecondary">
                Médicos vinculados
              </Typography>
              <Typography variant="h6">{surgerie.procedure.doctors?.length || 0}</Typography>
            </SoftPanel>
            <SoftPanel>
              <Typography variant="caption" color="textSecondary">
                Pacotes previstos
              </Typography>
              <Typography variant="h6">{surgerie.procedure.packages?.length || 0}</Typography>
            </SoftPanel>
            <SoftPanel>
              <Typography variant="caption" color="textSecondary">
                Anestesista sugerido
              </Typography>
              <Typography variant="h6">{surgerie.procedure.anesthetist ? 'Sim' : 'Não'}</Typography>
            </SoftPanel>
          </ThreeGrid>
        ) : (
          <HelperNote>
            <InfoOutlined fontSize="small" />
            <Typography variant="caption">
              Primeiro selecione a especialidade. Depois o campo de procedimento será liberado.
            </Typography>
          </HelperNote>
        )}
      </CardBody>
    </GuidedCard>
  );
};

export default SurgerieSecondStep;
